'use client'
import OpportunityTable from "components/opportunity/OpportunityList"

export default function OpportunityListPage() {
    return(
        <OpportunityTable />
    );
}